import React, {Component} from 'react';
import {connect} from "react-redux";
import {Button, Col, Row} from "reactstrap";
import * as actions from "../../../../actions";
import api from "../../../../util/clipstore/broadcaster/subscription_api";
import library from "../../../../util/clipstore/broadcaster/library";
import LabelFormField from "../../../../components/LabelFormFields";
import SubscriptionPriceDropDownComponent
    from "../../../../components/clipstore/broadcaster/library/profile/subscription/price-dropdown";
import assets from "../../../../util/assets";
import * as _ from 'lodash';
import {BROADCASTER, getUserDetail} from "../../../../util/account_management";

class BroadcasterSubscriptionContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            defaultSubscription: {},
            defaultSubscriptionPrice: "",
            subscriptionPackage: [],
            subscriptionPackagePrices: {},
            id: {},
            termsAndConditionChecked: false
        }
    }

    componentDidMount() {
        const id = getUserDetail(this.props, BROADCASTER, "id");
        if (id && typeof id !== undefined && parseInt(id) > 0) {
            api.getMySubscriptionPackageAPI(this.props);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {


        library.handleAPIResponse(nextProps, "get_my_subscription", () => {
            console.log("get_my_subscription", nextProps.get_my_subscription.payload)

            if (nextProps.get_my_subscription.payload &&
                nextProps.get_my_subscription.payload.hasOwnProperty("data") &&
                nextProps.get_my_subscription.payload.data &&
                Array.isArray(nextProps.get_my_subscription.payload.data)) {
                this.setState({
                    subscriptionPackage: nextProps.get_my_subscription.payload.data
                }, () => {
                    //callback
                    let pricesObject = {};
                    this.state.subscriptionPackage.map((value, index) => {
                        if (value.is_current === 1) {
                            this.setState({
                                defaultSubscription: value,
                                id: value.id,
                                defaultSubscriptionPrice: value.id
                            })
                        }

                        pricesObject[value.id] = value.name;
                    })

                    this.setState({
                        subscriptionPackagePrices: pricesObject,
                    }, () => {
                        console.log("BroadcasterSubscriptionContainer", {
                            defaultSubscription: this.state.defaultSubscription,
                            defaultSubscriptionPrice: this.state.defaultSubscriptionPrice,
                            subscriptionPackage: this.state.subscriptionPackage,
                            subscriptionPackagePrices: this.state.subscriptionPackagePrices,
                        })
                    })
                })
            }
            this.props.resetMySubscriptionPackage();
        }, () => {

        }, () => {

        }, true, true);

        library.handleAPIResponse(nextProps, "update_my_subscription", () => {
            api.getMySubscriptionPackageAPI(this.props);
            this.props.resetUpdateMySubscription();
        }, () => {
        }, () => {

        });
    }

    toggleTermsAndConditionChecked = () => {
        this.setState({
            termsAndConditionChecked: !this.state.termsAndConditionChecked
        })
    }

    setSubscriptionPrice = (id) => {
        console.log("subscription", id)
        this.setState({
            id
        })
    }

    updateSubscription = () => {
        api.updateMySubscriptionAPI(this.props, this.state.id);
    }

    render() {
        return (
            <div>
                <Row>
                    <Col md="6">
                        <LabelFormField label={"Subscribe to"} value={"Channel"} type={"dropdown"} disabled={true}/>

                        <LabelFormField label={"Subscribe term"} value={"Monthly"} type={"dropdown"} disabled={true}/>

                        {
                            this.state.defaultSubscriptionPrice !== "" &&
                            !_.isEmpty(this.state.subscriptionPackagePrices) &&
                            <SubscriptionPriceDropDownComponent
                                defaultSubscriptionPrice={this.state.defaultSubscriptionPrice}
                                subscriptionPackagePrices={this.state.subscriptionPackagePrices}
                                setSubscriptionPrice={this.setSubscriptionPrice}/>
                        }

                        <div className="display-flex-align-center label-form-field-container">
                            <div className="form-group"
                                 key={`select-gallery-modal-gallery-item-1`}>
                                <label className="custom-checkbox-container">Terms and Conditions
                                    <input type="checkbox" name="checkbox"
                                           onClick={this.toggleTermsAndConditionChecked}/>
                                    <span className="checkmark"></span>
                                </label>
                            </div>

                            <div className="form-group" style={{paddingLeft: 10, marginTop: -5}}>
                                <a href="https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/EULA/terms.html"
                                   title="Terms and conditions" target="_blank">T & C's</a>
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className="divider-copy"/>

                <Row className="display-flex-vertical-center no-margin button-container" style={{padding: 16}}>
                    <Col md="8" className="no-padding"/>
                    <Col md="2" className="no-padding">
                        <Button color="outline-secondary" onClick={() => {

                        }}>
                            RESET
                        </Button>
                    </Col>
                    <Col md="2" className="no-padding">
                        <Button color="primary"
                                disabled={!this.state.termsAndConditionChecked} onClick={this.updateSubscription}>
                            {
                                this.props.update_my_subscription.isFetching
                                    ?
                                    <img
                                        src={assets.loading_white}
                                        alt={"Loading"}
                                        width={26}
                                        height={26}
                                    />
                                    :
                                    "SAVE CHANGES"
                            }

                        </Button>
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        device: state.device.payload,
        get_my_subscription: state.get_my_subscription,
        update_my_subscription: state.update_my_subscription
    };
}

export default connect(mapStateToProps, actions)(BroadcasterSubscriptionContainer);
